// extracted by mini-css-extract-plugin
export default {"container":"TemplateTab_container__ey54T","header":"TemplateTab_header__psy9T","info":"TemplateTab_info__xCRnK","sideContainer":"TemplateTab_sideContainer__Z2QA2"};